import { html } from "lit";
import { customElement, property } from "lit/decorators.js";

import AtlasElement, { AtlasElementProps } from "@/components/atlas-element";
import styles from "./atlas-card-input.scss";

export type CardInputProps = AtlasElementProps & {
    text: string;
};

/**
 * Descrição do componente
 *
 * @prop {string} text - Propriedade texto
 *
 * @tag atlas-card-input
 */
@customElement("atlas-card-input")
export default class AtlasCardInput extends AtlasElement {
    static styles = styles;

    @property({ type: String }) text: string;

    render() {
        return html`
            <div>
                <slot></slot>
            </div>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "atlas-card-input": AtlasCardInput;
    }
}
